






import { mapGetters } from 'vuex'
import Vue from 'vue'
import { signoutConfirm } from '@/utility/helpers'
export default Vue.extend({
    computed: {
        ...mapGetters(['user']),
        hide(): boolean {
            //  Array of routes we do not want to display on
            const hide = {
                '/': true,
                '/register/user': true,
                '/signin': true
            }

            //  Hide if we are on one of those routes
            return hide[this.$route.path] || false
        }
    },
    methods: {
        goToHome(): void {
            //  If an authenticated user does NOT exist, route to home
            if (!this.user) return this.$router.push('/')

            //  Else, we need to signout the user, so pop signout confirm
            signoutConfirm()
        }
    }
})
